import { render, staticRenderFns } from "./customer_list.vue?vue&type=template&id=db2dd9a8&scoped=true"
import script from "./customer_list.vue?vue&type=script&lang=js"
export * from "./customer_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2dd9a8",
  null
  
)

export default component.exports